import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import messages from '../messages'

import Step from '../Step/Step'
import Option from '../Option/Option'
import ScentOption from '../ScentOption/ScentOption'
import MonthOption from '../MonthOption/MonthOption'


const Steps = (props) => {
  const { className, plans, currScentIndex, activeScentIndex, currMonthIndex, activeMonthIndex, onFirstClick } = props

  if (!plans || !plans.length) {
    return null
  }

  const scentOptions        = plans.map(({ scentCount }) => ({ scentCount }))
  const monthAllOptions     = plans.map(({ plans }) => plans)
  const isMonthStepVisible  = typeof activeScentIndex === 'number'
  const monthOptions        = isMonthStepVisible && monthAllOptions[activeScentIndex]

  const scentDataTestIds = [
    constants.testIds.upgrade.options.onePerMonth,
    constants.testIds.upgrade.options.twoPerMonth,
    constants.testIds.upgrade.options.threePerMonth,
  ]
  const monthDataTestIds = [
    constants.testIds.upgrade.options.monthly,
    constants.testIds.upgrade.options.quarter,
    constants.testIds.upgrade.options.semiAnnual,
    constants.testIds.upgrade.options.annual,
  ]

  return (
    <div className={className}>
      <Step
        title={messages.step1Title}
        desc={messages.scentStepDesc}
        options={scentOptions}
      >
        {
          (option, index) => (
            <Option
              key={index}
              isCurrent={currScentIndex === index}
              isActive={activeScentIndex === index}
              onSelect={() => {
                actions.models.upgradeSubscriptionFlow.setActiveScentIndex(index)
                onFirstClick()
              }}
              dataTestId={scentDataTestIds[index]}
            >
              <ScentOption option={option} isActive={activeScentIndex === index} />
            </Option>
          )
        }
      </Step>
      {
        isMonthStepVisible && (
          <Step
            title={messages.step2Title}
            desc={messages.monthStepDesc}
            options={monthOptions}
          >
            {
              (option, index) => (
                <Option
                  key={index}
                  isCurrent={currScentIndex === activeScentIndex && currMonthIndex === index}
                  isActive={activeMonthIndex === index}
                  onSelect={() => {
                    actions.models.upgradeSubscriptionFlow.setActiveMonthIndex(index)
                    onFirstClick()
                  }}
                  dataTestId={monthDataTestIds[index]}
                >
                  <MonthOption option={option} />
                </Option>
              )
            }
          </Step>
        )
      }
    </div>
  )
}

Steps.propTypes = {
  currScentIndex: PropTypes.number,
  activeScentIndex: PropTypes.number,
  currMonthIndex: PropTypes.number,
  activeMonthIndex: PropTypes.number,
  onFirstClick: PropTypes.func,
}

Steps.defaultProps = {
  currScentIndex: 0,
  activeScentIndex: 0,
  currMonthIndex: 0,
  activeMonthIndex: 0,
}


export default connect({
  plans: 'models.subscription.plans',
  currScentIndex: 'models.upgradeSubscriptionFlow.currScentIndex',
  activeScentIndex: 'models.upgradeSubscriptionFlow.activeScentIndex',
  currMonthIndex: 'models.upgradeSubscriptionFlow.currMonthIndex',
  activeMonthIndex: 'models.upgradeSubscriptionFlow.activeMonthIndex',
})(Steps)
